var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playlist"
  }, [_c('h4', [_vm._v("\n    " + _vm._s(_vm.playlist.name) + "\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Episode',
        params: {
          number: _vm.episode.number
        }
      }
    }
  }, [_c('small', {
    staticClass: "text-primary"
  }, [_vm._v("from Show #" + _vm._s(_vm.episode.number))])])], 1), _vm._v(" "), _c('section', {
    staticClass: "section-center row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-responsive",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tbody', _vm._l((_vm.tracks), function(track) {
    return _c('tr', [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n              " + _vm._s(track.number) + "\n              "), _c('small', [_c('a', {
      attrs: {
        "href": _vm.audioAtTime(track.startAt),
        "target": "_blank"
      }
    }, [_c('svg', {
      staticClass: "icon"
    }, [_c('use', {
      attrs: {
        "xlink:href": "#play"
      }
    })]), _vm._v("\n                  ~" + _vm._s(_vm.duration(track.startAt)) + "\n                ")])])]), _vm._v(" "), _c('td', [_c('track-row', {
      attrs: {
        "track-id": track.trackId
      }
    })], 1)])
  }))])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Tracks")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17a67d14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Playlist.vue
// module id = 48Ha
// module chunks = 1